<script>
  /* Executable code section of the program */
  //Tools importation
  import { userRealTime, temporalData, isPollModalOn,pollsArray } from "../apis/storage";
  import { getSpecificPollDocuments, listenToCollection, updateMultipleDocuments } from "../apis/APIS";
  import { onDestroy, onMount } from "svelte";
  //Components importation
  import QuestionCard from "./Cards/QuestionCard.svelte";

  //Auxiliary variables
  $: dinamicPoll = []
  $: dinamicSelect = []
  let updatePolls = []
  let unsubscribePolls;

  //Function to display polls modal
  const displayModal = () => {
    $isPollModalOn = true;
  };

  //Function to change active poll
  const changePoll = () =>{    
    let pollSelected = document.querySelector(".pollSelect")
    let selectValue = pollSelected.value
    dinamicPoll[0].isActivePoll = false
    updatePolls.push({
      id:dinamicPoll[0].id,
      fieldName:"isActivePoll",
      values: false
    })
    dinamicPoll = $pollsArray.filter(element => element.questionTittle === selectValue)
    dinamicPoll[0].isActivePoll = true
    dinamicPoll[0].isActivePoll = false
    updatePolls.push({
      id:dinamicPoll[0].id,
      fieldName:"isActivePoll",
      values: true
    })
    updateMultipleDocuments("polls",updatePolls,false)
  }

  // Select active poll
  function updateActivePoll(polls) {

    const activePoll = polls.find(element => element.isActivePoll === true);
    if (activePoll) {
      dinamicPoll = [activePoll];
    } else {
      dinamicPoll = polls.slice(-1);
    }
  }

   onMount(async () => {
    $pollsArray = await getSpecificPollDocuments("event", $temporalData.tittle); 
    updateActivePoll($pollsArray);

    unsubscribePolls = listenToCollection("polls", (activePoll) => {
  if (!activePoll || Object.keys(activePoll).length === 0) {
    dinamicPoll = $pollsArray.slice(-1); // Mantenemos último poll válido
  } else {
    dinamicPoll = [activePoll]; // Encapsulado en array para mantener estructura
  }
});
  }); 


  onDestroy(() => {
    if (unsubscribePolls) unsubscribePolls(); // Clean listener
  });
  
  /* End of the section */
</script>

<!-- Section to place the HTML code -->
{#if $pollsArray.length > 0}
  <section class="principalContainer">
    {#if $userRealTime.userRole !== "attendee"}
    <div class="buttonsContainer">
      <div class="filterQuestion">
        <div class="form-floating">
          <select
            class="form-select pollSelect"
            name="company"
            id="floatingSelect"
            aria-label="Floating label select example"
            on:change={changePoll}
          >
            <option selected value="">Select a question</option>
            {#each $pollsArray as poll}
            <option value="{poll.questionTittle}">{poll.questionTittle}</option>
            {/each}
          </select>
          <label for="floatingSelect">Questions</label>
        </div>
        <button class="actionBtn hoverActionBtn changeBtn"
        on:click={changePoll}
          >Change Question</button
        >
      </div>
      <div class="controlButtons">
        <button
          class="actionBtn hoverActionBtn customBtn"
          on:click={displayModal}
          ><svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="currentColor"
            class="bi bi-plus-square"
            viewBox="0 0 16 16"
          >
            <path
              d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"
            />
            <path
              d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"
            />
          </svg></button
        >
      </div>
    </div>
    {/if}
    <div class="cardContainer">
      <QuestionCard poll = {dinamicPoll}/>
    </div>
  </section>
{:else}
  <section class="emptySection">
    {#if $userRealTime.userRole !== "attendee"}
      <button class="actionBtn hoverActionBtn" on:click={()=>$isPollModalOn=true}>Add Poll</button>
    {:else}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="50"
        height="50"
        fill="currentColor"
        class="bi bi-ui-checks"
        viewBox="0 0 16 16"
      >
        <path
          d="M7 2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5zM2 1a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm0 8a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2zm.854-3.646a.5.5 0 0 1-.708 0l-1-1a.5.5 0 1 1 .708-.708l.646.647 1.646-1.647a.5.5 0 1 1 .708.708zm0 8a.5.5 0 0 1-.708 0l-1-1a.5.5 0 0 1 .708-.708l.646.647 1.646-1.647a.5.5 0 0 1 .708.708zM7 10.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5zm0-5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0 8a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5"
        />
      </svg>
      <p class="emptyText">No polls have been enabled for this event.</p>
    {/if}
  </section>
{/if}

<!-- End of the section -->
<style>
  /* Section to place the code styles */
  /* Principal styles */
  /* Empty styles */
  .emptySection {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    height: 30vh;
    background-color: #f4f4f4;
  }
  .emptyText {
    text-align: center;
  }
  /* Content styles */
  .principalContainer {
    width: 90%;
    height: auto;
    min-height: 30vh;
    background-color: #f4f4f4;
  }
  /* Button styles */

  .actionBtn {
    width: 250px;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 500;
    padding: 8px 16px;
    background-color: white;
    color: #111;
    border: 1px solid #444;
    transition: all 0.3s ease-in-out;
    margin: 0 20px;
  }

  .hoverActionBtn:hover {
    cursor: pointer;
    box-shadow: #000 0px 0px 5px;
    transform: scale(1.01);
    border-color: #fff;
    background-color: #ed2824;
    color: White;
  }
  .changeBtn {
    margin: 0 20px;
    width: 200px;
  }
  .customBtn {
    width: 100px;
    margin: 0 5px;
  }
  /* Control section styles */
  .buttonsContainer {
    width: 100%;
    height: auto;
    display: flex;
    justify-content: space-between;
    padding: 20px;
  }
  .filterQuestion {
    width: 50%;
    height: auto;
    display: flex;
  }
  .pollSelect {
    height: 50px;
    overflow: auto;
  }
  .controlButtons {
    width: 50%;
    height: auto;
    display: flex;
    justify-content: flex-end;
  }
  /* Select styles */
  .form-floating {
    width: 400px;
  }

  /* /////////Tablets///////// */
  @media (min-width: 700px) and (max-width: 1100px) {.buttonsContainer {
    width: 100%;
    justify-content: center;
    align-items: flex-start;
    padding: 5px;
  }
  .filterQuestion{
    align-items: flex-start;
  }
  .form-floating{
    width: 300px;
    align-items: flex-start;
    margin: 5px;
  }
  .actionBtn {
    width: 250px;
    margin: 5px;
  }
  .customBtn {
    width: 200px;
    margin: 5px;
  }
  }
  /* /////////Cellphones ///////// */
  @media (max-width: 700px) {
    /* Control section styles */
  .buttonsContainer {
    width: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding: 5px;
  }
  .filterQuestion{
    flex-direction: column;
    align-items: flex-start;

  }
  .form-floating{
    width: 300px;
    align-items: flex-start;
    margin: 5px;
  }
  .actionBtn {
    width: 300px;
    margin: 5px;
  }
  .customBtn {
    width: 300px;
    margin: 5px;
  }
    .emptySection {
      padding: 20px;
    }
  }
  /* End of the section */
</style>
